import axios from "axios";
import api from "./api";
import API_BASE_URL from "../config/apiConfig";

// The e-pass list Dynamic Pricing and Manage Bookings pick from.
export const listEpasses = async () => (await api.get("/api/admin/epasses")).data;
export const saveEpass = async (epass) =>
  (epass.id
    ? await api.put(`/api/admin/epasses/${epass.id}`, epass)
    : await api.post("/api/admin/epasses", epass)
  ).data;
export const deleteEpass = (id) => api.delete(`/api/admin/epasses/${id}`);

// One booking's e-passes. Every change answers with { id, epasses } for the bookings row.
const bookingPath = (bookingId) => `/api/admin/bookings/${bookingId}/epasses`;

export const addBookingEpass = async (bookingId, epassId, neededOn) =>
  (await api.post(bookingPath(bookingId), { epassId, neededOn })).data;
export const updateBookingEpass = async (bookingId, epassId, { neededOn, notNeeded }) =>
  (await api.put(`${bookingPath(bookingId)}/${epassId}`, { neededOn, notNeeded })).data;
export const removeBookingEpass = async (bookingId, epassId) =>
  (await api.delete(`${bookingPath(bookingId)}/${epassId}`)).data;
export const uploadBookingEpass = async (bookingId, epassId, file) =>
  (await api.post(`${bookingPath(bookingId)}/${epassId}/file`, fileForm(file), {
    headers: { "Content-Type": "multipart/form-data" },
  })).data;
export const removeBookingEpassFile = async (bookingId, epassId) =>
  (await api.delete(`${bookingPath(bookingId)}/${epassId}/file`)).data;
// Behind the admin login, so it comes back as a blob rather than a link.
export const fetchBookingEpassFile = async (bookingId, epassId) =>
  (await api.get(`${bookingPath(bookingId)}/${epassId}/file`, { responseType: "blob" })).data;

// Transport owner portal: the link's access key is the only credential.
const ownerPath = (accessKey, bookingId, epassId) =>
  `${API_BASE_URL}/api/transport-owner/portal/${encodeURIComponent(accessKey)}/bookings/${bookingId}/epasses/${epassId}/file`;
export const ownerEpassFileUrl = (accessKey, bookingId, epassId, download = false) =>
  `${ownerPath(accessKey, bookingId, epassId)}${download ? "?download=true" : ""}`;
export const uploadOwnerEpass = async (accessKey, bookingId, epassId, file) =>
  (await axios.post(ownerPath(accessKey, bookingId, epassId), fileForm(file), {
    headers: { "Content-Type": "multipart/form-data" },
  })).data;

// Driver trip link: download only.
export const driverEpassFileUrl = (token, epassId, download = false) =>
  `${API_BASE_URL}/api/driver/booking/${encodeURIComponent(token)}/epasses/${epassId}/file${download ? "?download=true" : ""}`;

function fileForm(file) {
  const form = new FormData();
  form.append("file", file);
  return form;
}
